import store from '@/assets/js/vue/vuex';
import {actions, mutations} from '@/assets/js/vue/vuex/actions';

export const ws = {
  _socket: null,
  _reconnectTimeout: null,
  _reconnectAttempt: 0,
  _closedManually: false,

  init() {
    if (this._socket && this._socket.readyState !== WebSocket.CLOSED) {
      return;
    }

    this._closedManually = false;
    this._clearReconnectTimeout();
    this._connect();
  },

  _connect() {
    if (!store.getters.isLogged) {
      return;
    }

    const socket = new WebSocket(process.env.VUE_APP_BACKEND_TRACCAR_WS);
    this._socket = socket;

    socket.onopen = () => {
      this._reconnectAttempt = 0;
    };

    socket.onmessage = this.onmessage;

    socket.onerror = error => {
      console.error('Traccar WebSocket error:', error);
      socket.close();
    };
    socket.onclose = () => {
      if (this._socket !== socket || this._closedManually || !store.getters.isLogged) {
        return;
      }

      this._socket = null;
      this._scheduleReconnect();
    };
  },

  onmessage(event) {
    const data = JSON.parse(event.data);

    if (data.positions !== undefined) {
      store.commit(mutations.APPEND_POSITIONS, data.positions);
      store.dispatch(actions.UPDATE_POSITION_ATTRIBUTES);
    }

    if (data.devices !== undefined) {
      store.commit(mutations.APPEND_DEVICES, data.devices);
    }

    if (data.events !== undefined) {
      data.events.forEach(value => {
        if (value?.attributes?.message) {
          store.dispatch(actions.EVENT_RECEIVED, value);
        }
      })
    }
  },

  _scheduleReconnect() {
    this._clearReconnectTimeout();

    const backoffDelay = Math.min(1000 * (2 ** this._reconnectAttempt), 30000);
    const delay = Math.min(backoffDelay * (0.75 + Math.random() * 0.5), 30000);
    this._reconnectAttempt += 1;

    this._reconnectTimeout = setTimeout(() => {
      this._reconnectTimeout = null;

      if (this._closedManually || !store.getters.isLogged) {
        return;
      }

      this._connect();
    }, delay);
  },

  _clearReconnectTimeout() {
    if (this._reconnectTimeout !== null) {
      clearTimeout(this._reconnectTimeout);
      this._reconnectTimeout = null;
    }
  },

  close() {
    this._closedManually = true;
    this._clearReconnectTimeout();
    this._reconnectAttempt = 0;

    const socket = this._socket;
    this._socket = null;
    socket?.close();
  }
};
